import styled from "styled-components";

export const Container = styled.div`
  margin-top: 2rem;

  .ant-rate-star.ant-rate-star-full {
    svg {
      color: #fbcb00;
    }
  }

  .ant-progress-text {
    color: ${({ theme }) => theme.colors.textColor};
  }

  .ant-card {
    border-radius: 10px;

    border-color: transparent;
    background: ${({ theme }) => theme.colors.modalBackgroundColor};
  }

  .ant-card-head {
    border-color: ${({ theme }) => theme.colors.backgroundColor};
  }

  .ant-card-head-title {
    padding: 1rem 0;
    font-size: 20px;
    font-weight: 400;

    .section-title {
      color: ${({ theme }) => theme.colors.textColor};
    }

    .ant-badge-not-a-wrapper {
      color: ${({ theme }) => theme.colors.textMasterColor};
    }

  }

  .section-title {
    margin: 0px 15px 0px 0px;
    font-size: 20px;
  }

  .add-review-btn {
    margin: 5px 0 0;
    
    span {
      color: ${({ theme }) => theme.colors.textMasterColor} !important;
    }
  }

  .spin-container {
    display: flex;
    margin-top: 40px;
    align-items: center;
    justify-content: center;
  }

  .ant-empty-description {
    color: ${({ theme }) => theme.colors.textColor};
  }

  .ant-pagination {
    .ant-pagination-item {
      border-color: ${({ theme }) => theme.colors.btnTextColor};

      a {
        color: ${({ theme }) => theme.colors.textColor};
      }
    }

    .ant-pagination-item-link {
      color: ${({ theme }) => theme.colors.textColor};
    }

    .ant-pagination-item-active {
      border-color: ${({ theme }) => theme.colors.primary};

      a {
        color: ${({ theme }) => theme.colors.primary};
      }
    }

    li a,
    li button {
      border-color: ${({ theme }) => theme.colors.btnTextColor};
      background: ${({ theme }) => theme.colors.backgroundColor};
    }
  }
`;

export const Content = styled.div`
  margin-top: 25px;

  .feedback-container {
    display: flex;
    align-items: center;

    .average-section {
      display: flex;
      margin-right: 50px;
      flex-direction: column;

      h1 {
        font-size: 60px;
        margin: -5px 0 0;
      }
    }

    .rate-rows-container {
      flex: auto;
      display: flex;
      flex-direction: column;

      .rate-filter-btn {
        border: none;
        cursor: pointer;
        background: none;

        &:focus {
          border-radius: 8px;
          box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.15);
        }
      }

      .rate-row {
        flex: auto;
        display: flex;
        align-items: center;

        .progress-bar-col {
          flex: auto;
          display: flex;
          margin-right: 20px;
          align-items: center;

          .ant-progress-line {
            margin: 0;

            .ant-progress-text {
              color: ${({ theme }) => theme.colors.textColor};
            }
          }
        }

        .rate-col {
          display: flex;
          margin-right: 20px;
          align-items: center;

          .ant-rate {
            margin-top: -5px;

            .ant-rate-star {
              cursor: pointer;
            }
          }

          .mobile-rate {
            display: none;
          }
        }

        .badge-col {
          display: flex;
          min-width: 32px;
          margin-top: 4px;
          align-items: center;
        }
      }
    }

    @media screen and (max-width: 1200px) {
      flex-direction: column;

      .average-section {
        flex: 1;
        margin-right: 0;
        align-items: center;
      }

      .rate-rows-container {
        width: 100%;
      }
    }

    @media screen and (max-width: 430px) {
      .rate-rows-container .rate-row .rate-col {
        .ant-rate {
          display: none;
        }

        .mobile-rate {
          display: flex;
          align-items: center;

          p {
            font-size: 16px;
            margin: 0 3px 0 0;
          }

          svg {
            font-size: 20px;
          }
        }
      }
    }
  }
`;

export const PaginationContainer = styled.div`
  display: flex;
  margin: 25px 0 0;
  align-items: center;
  justify-content: center;

  .ant-pagination > li {
    margin-bottom: 5px;
  }

  svg {
    color: ${({ theme }) => theme.colors.textColor};
  }
`;
